import { Slider as SliderType } from '../../../../../../types/Survey/Element'
import { Props } from './types'
import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'
import Core from './Core'
import Input from '../../../../../UI/Input/Input'
import Checkbox from '../../../../../UI/Checkbox/Checkbox'
import Number from '../../../../../UI/Input/Number'

const Slider: React.FC<Props<SliderType> & { disableCounterWeight?: boolean }> = ({ element, update, disableCounterWeight = false }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const set = (prop: keyof SliderType) => (value: any) => {
    update({ ...element, [prop]: value })
  }

  return (
    <div>
      <Core element={element} update={update} />
      <div className="flex gap-3 items-start">
        {!disableCounterWeight && (
          <div className="w-full">
            <Checkbox
              label={t.survey.configuration.slider.enableCounterWeight}
              checked={element.enableCounterWeight}
              onChange={set('enableCounterWeight')}
            />
            {!!element.enableCounterWeight && (
              <Input label={t.survey.configuration.slider.counterWeightText} value={element.counterWeightText} onChange={set('counterWeightText')} />
            )}
          </div>
        )}
        <Checkbox label={t.survey.configuration.slider.percentageLabel} checked={element.percentageLabel} onChange={set('percentageLabel')} />
      </div>
      <div className="flex flex-row gap-2">
        <Input label={t.survey.configuration.slider.leftLabel} value={element.leftLabel} onChange={set('leftLabel')} />
        <Number preserveZero label={t.survey.configuration.slider.leftValueLabel} value={element.leftValue} onChange={set('leftValue')} />
        <Input label={t.survey.configuration.slider.rightLabel} value={element.rightLabel} onChange={set('rightLabel')} />
        <Number preserveZero label={t.survey.configuration.slider.rightValueLabel} value={element.rightValue} onChange={set('rightValue')} />
      </div>
    </div>
  )
}

export default Slider
